import { Config } from "../config/config.js";
import { NotificationHelper } from "./notificationHelper.js";

interface MobileNotification {
    message: string;
    level: 'error' | 'warning' | 'info';
    timeoutInMs: number | null;
}

export class InnosoftMobileApp {
    public static showCloseButton: () => Promise<boolean> = () => dynamicInvoke("showCloseButton");
    public static close: () => Promise<void> = () => dynamicInvoke("close");
    public static subscribeToNotifications = (handler: (notificationInfo: MobileNotification) => void) => addEventListener('notification', handler);
    public static async isMobileDevice(): Promise<boolean> {
        if (Config.settings.isMobileApp) {
            let result = await dynamicInvoke("getScreenMode");
            return result == "small";
        } else
            return window.matchMedia("not all and (min-width: 600px) and (min-height: 528px)").matches
    }
}

function dynamicInvoke(functionName: string, args?) {
    return (window as any).InnosoftMobile.dynamicInvoke(functionName, args);
}

type RemoveFn = () => void;
function addEventListener(eventName: string, handler: (data: any) => void): RemoveFn {
    return (window as any).InnosoftMobile.addEventListener(eventName, handler);
}

export function startListenToNotificationsFromMobileApp() {
    InnosoftMobileApp.subscribeToNotifications(handleNewNotification);

    function handleNewNotification(notificationInfo: MobileNotification) {
        const options: ToastrOptions = {
            timeOut: notificationInfo.timeoutInMs,
            closeButton: true,
            positionClass: "toast-top-center",
            closeHtml: `<i class='fal fa-times'></i>`,
            preventDuplicates: true
        }

        switch (notificationInfo.level) {
            case "error":
                NotificationHelper.showErrorMessage(notificationInfo.message, options);
                break;
            case "info":
                NotificationHelper.showInfoMessage(notificationInfo.message, options);
                break;
            case "warning":
                NotificationHelper.showWarningMessage(notificationInfo.message, options);
                break;
        }
    }
}